import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { prettyFloatMoney } from '@/helpers/utils';
import { useGetFinances } from '@/query/queries/cash/useGetFinances';
import s from './index.module.scss';

export const NextRepaymentTooltip = ({ showWarning }) => {
  const { data: finances } = useGetFinances();
  const { t } = useTranslation('components');

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        {showWarning && (
          <div className={classnames(s.warning, 'f-label')}>
            {t('top_header.insufficient_funds_warning')}
          </div>
        )}
        <div className={s.row} style={{ color: 'var(--Black-400, #151515)' }}>
          <div className="f-body-regular">{t('top_header.next_repayment')}</div>
          <div className="f-body-medium">{prettyFloatMoney(finances?.business.next_payment)}</div>
        </div>
        <div className={s.row}>
          <div className="f-label">{t('top_header.next_repayment_payable')}</div>
          <div className="f-label">{prettyFloatMoney(finances?.business.next_payment_payable)}</div>
        </div>
        {!!finances?.business.next_payment_refinanced && (
          <div className={s.row}>
            <div className="f-label">{t('top_header.next_repayment_refinanced')}</div>
            <div className="f-label">
              {prettyFloatMoney(finances?.business.next_payment_refinanced)}
            </div>
          </div>
        )}
      </div>
      <div className={classnames(s.note, 'f-label')}>{t('top_header.amount_of_next_loan')}</div>
    </div>
  );
};
